import { render, staticRenderFns } from "./UserEditTabPerfils.vue?vue&type=template&id=dbdbb0b6&"
import script from "./UserEditTabPerfils.vue?vue&type=script&lang=js&"
export * from "./UserEditTabPerfils.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabPerfils.vue?vue&type=style&index=0&id=dbdbb0b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports